{
  "$schema": "https://mux.run/theme.json",
  "name": "Catppuccin",
  "id": "catppuccin",
  "light": {
    "palette": {
      "neutral": "#f5e0dc",
      "ink": "#4c4f69",
      "primary": "#7287fd",
      "accent": "#d20f39",
      "success": "#40a02b",
      "warning": "#df8e1d",
      "error": "#d20f39",
      "info": "#04a5e5",
      "diffAdd": "#a6d189",
      "diffDelete": "#e78284"
    },
    "overrides": {
      "syntax-comment": "#6c7086",
      "syntax-keyword": "#8839ef",
      "syntax-primitive": "#1e66f5",
      "syntax-constant": "#ca6702"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#1e1e2e",
      "ink": "#cdd6f4",
      "primary": "#b4befe",
      "accent": "#f38ba8",
      "success": "#a6d189",
      "warning": "#f4b8e4",
      "error": "#f38ba8",
      "info": "#89dceb",
      "diffAdd": "#94e2d5",
      "diffDelete": "#f38ba8"
    },
    "overrides": {
      "syntax-comment": "#6c7086",
      "syntax-keyword": "#cba6f7",
      "syntax-primitive": "#89b4fa",
      "syntax-constant": "#fab387"
    }
  }
}
